// Mantém Boletos disponível no sistema, mas oculto na navegação e nas permissões.
export const showBoletosMenu = false;
